import { createContext } from 'react';
import { IMovContextData } from 'interfaces/movements';

export const MovContext = createContext<IMovContextData | null>(null);
